import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutModule, SharedModule } from '@app/shared';
import { MaterialModule } from '@app/shared/material.module';
import { AuthenticationGuard as AuthGuard } from '@app/shared/services/authguards';
import { StateAddEditComponent, StateListComponent } from '@user/components/province';

const routes: Routes = [
  { path: 'list', component: StateListComponent, canActivate: [AuthGuard], data: { title: 'Province' } }
];
@NgModule({
  declarations: [StateListComponent, StateAddEditComponent],
  imports: [
    RouterModule.forChild(routes),
    LayoutModule,
    MaterialModule,
    SharedModule
  ],
  entryComponents: [StateAddEditComponent]
})
export class ProvinceModule { }